<template>
  <div>
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>
    </header>

    <div class="info-wrapper">
      <div class="info">
        <h4>{{ examName }}</h4>
        <span class="stud-info">{{ gradeName }} {{ className }}班 {{ studentName }} </span>
      </div>
      <div v-loading="dataLoading" class="preview-common-box">
        <el-button type="primary" plain round size="small" @click="previewOn">预览试卷</el-button>
      </div>
    </div>

    <div class="main">
      <div class="nav-wrap">
        <nav-bar :routers="routers" :class="postionClass"></nav-bar>
      </div>
      <router-view v-if="showReport" :subject-name="subjectName" :report-type="reportType" :student-exam-data.sync="studentExamData"></router-view>
    </div>
    <yue-dialog title="作答信息" :visible.sync="previewVisible" width="800px">
      <div class="topic-info">
        <span>姓名：{{ previewStudentInfo.studentName }}</span>
        <span>班级：{{ previewStudentInfo.studClass }}</span>
        <span>学号：{{ previewStudentInfo.studNo }}</span>
      </div>
      <div v-for="key in Object.keys(previewMap)" :key="key">
        <p class="topic-title">{{ key }}（{{ previewMap[key].totalPoint }}分）</p>
        <el-table :data="previewMap[key].list" style="width: 100%;margin-bottom: 20px" size="small" border>
          <el-table-column prop="date" label="小题号">
            <template slot-scope="scope">
              <span>{{ scope.row.question }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" align="center" label="学生作答">
            <template slot-scope="scope">
              <span v-if="scope.row.answer && scope.row.ossUrl.indexOf('none.jpg') > -1">{{ scope.row.answer }}</span>
              <div style="display: flex;flex-direction: column;align-items: center;" v-else-if="scope.row.ossUrl.indexOf('none.jpg') === -1">
                <el-image v-for="(img, imgIndex) in scope.row.ossUrlList" alt="answer" style="height: 100px;margin-bottom: 10px" :key="scope.$index + 'img' + imgIndex" :src="img" :preview-src-list="scope.row.ossUrlList" />
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="标准答案">
            <template slot-scope="scope">
              <span>{{ scope.row.standAnswer || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="得分">
            <template slot-scope="scope">
              <span>{{ scope.row.realScore === null ? '-' : scope.row.realScore }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </yue-dialog>

    <!-- 利用el-image实现代码控制预览图片 -->
    <el-image class="priview-img" ref="priview" :src="previewImg.src" :preview-src-list="previewImg.list"></el-image>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import { getDistinguish, getExam, getMarkingPaperInfo } from '@/api/exam/exam'
import { mapGetters } from 'vuex'
import util from '@/utils/util'
import { xDraw } from '@/utils/draw.js'
import { reportApi } from '@/v2/utils/api'

export default {
  data () {
    return {
      ifHistoryData: false,
      importType: 0,
      reportType: 0,
      showReport: false, // 是否展示报告
      schoolId: '',
      examId: '',
      examName: '',
      classId: '',
      studentId: '',
      className: '',
      gradeName: '',
      subjectName: '',
      studentName: '',
      dataLoading: false,
      studentExamData: {},
      routers: [],
      previewVisible: false,
      previewMap: {},
      previewStudentInfo: {},

      //左侧栏
      postionClass: '',
      previewImg: { src: '', list: [] }
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      gradeList: 'getGradeList'
    })
  },

  created () {
    this.reportType = parseInt(this.$route.query.reportType)
    this.schoolId = this.userInfo.schoolId
    this.examId = this.$route.params.examId
    this.classId = this.$route.params.classId
    this.className = this.$route.query.className
    this.studentId = this.$route.params.studentId
    this.studentName = this.$route.query.name

    this.routers = [
      {
        path:
          '/exam/single/report/class/transcript/' +
          this.examId +
          '/' +
          this.classId +
          '/' +
          this.studentId +
          '/transcriptBasic?name=' +
          this.studentName +
          '&reportType=' +
          this.reportType +
          '&className=' +
          this.className,
        name: '个人成绩单报告'
      },
      {
        path:
          '/exam/single/report/class/transcript/' +
          this.examId +
          '/' +
          this.classId +
          '/' +
          this.studentId +
          '/transcriptMistakes?name=' +
          this.studentName +
          '&reportType=' +
          this.reportType +
          '&className=' +
          this.className,
        name: '错题集'
      }
    ]
  },

  beforeRouteLeave (to, from, next) {
    watermark.load({ show: false })
    watermark.remove()
    next()
  },

  mounted () {
    this.ifHistoryData = sessionStorage.getItem('history') == 1 ? true : false

    this._getExam()
    this._initNavScroll()
    this.initWaterMark()
  },

  methods: {
    handlePreview (list, index) {
      this.previewImg.src = list[0]
      this.previewImg.list = list
      this.$refs.priview.showViewer = true;
    },
    initWaterMark () {
      if (sessionStorage.getItem('region-report-watermark') === '1') {
        watermark.init({
          watermark_txt: this.userInfo.nickName + '\n' + this.userInfo.loginName + '\n' + util.formatDate(new Date()),
          watermark_color: '#e2e2e2', //水印字体颜色
          watermark_fontsize: '14px', //水印字体大小
          watermark_alpha: 0.5, //水印透明度，要求设置在大于等于0.005
          watermark_angle: 25, //水印倾斜度数
          watermark_width: 100, //水印宽度
          watermark_height: 100, //水印长度
          watermark_parent_node: '',
          monitor: false,
          show: true
        })
        watermark.load({
          show: true
        })
      }
    },
    //根据examId查询考试、班级信息
    async _getExam () {
      let resp = await getExam(this.examId)
      try {
        const exam = resp.body
        let subjectCode = exam.subjectCode
        this.examName = exam.examName
        this.importType = exam.importType || 0
        this.subjectName = exam.subjectName
        this.gradeName = this._getGradeName(exam.grade)
        this.$set(this.routers, 1, {
          name: '错题集',
          path:
            '/exam/single/report/class/transcript/' +
            this.examId +
            '/' +
            this.classId +
            '/' +
            this.studentId +
            '/transcriptMistakes?name=' +
            this.studentName +
            '&reportType=' +
            this.reportType +
            '&className=' +
            this.className +
            '&hasPaper=' +
            exam.hasPaper
        })
      } catch (e) { }

      this._studentBase()
    },

    _getGradeName (gradeNum) {
      let grade = this.gradeList.find((item) => item.gradeNum === gradeNum)
      return grade ? grade.gradeName : ''
    },

    previewOn () {
      if (this.importType === 1) {
        this.$message.warning('该考试为导入的考试，没有学生试卷~')
        return
      }

      if (this.studentExamData.markPaperUrl) {
        this.previewImg.src = this.studentExamData.markPaperUrl[0]
        this.previewImg.list = this.studentExamData.markPaperUrl
        this.dataLoading = false
        this.$refs.priview.showViewer = true;
        return
      }

      const wayFlag = this.studentExamData.canPreviewPaper
      if (!wayFlag) {
        this.$message.warning('未获取到原卷~')
        return
      }

      const examResultId = this.studentExamData.resultIds
      if ((wayFlag) && examResultId && examResultId.length > 0) {
        this.dataLoading = true
        let params = {
          schoolId: this.schoolId,
          examId: this.examId,
          resultIds: examResultId.split(','),
        }
        const promise1 = getMarkingPaperInfo(params)

        xDraw.markPaper(promise1).then(resp => {
          this.dataLoading = false
          if (resp.success && (resp.body || []).length) {
            this.previewImg.src = resp.body[0]
            this.previewImg.list = resp.body
            this.studentExamData.markPaperUrl = resp.body
            this.$refs.priview.showViewer = true;
          } else {
            return this.$message.warning('获取学生原卷失败！')
          }
        })
      } else if (wayFlag + '' === '1') {
        this.getImportPaper()
      }
    },

    // 查看导入试卷
    async getImportPaper () {
      let res = await getDistinguish({
        resultId: this.$route.query.examResultId,
        examId: this.examId
      });
      if (res.success) {
        if (res.body) {
          let list = res.body.details, previewMap = {}
          this.previewStudentInfo = {
            ...list[0],
            studentName: this.studentName
          }
          for (let item of list.slice(1)) {
            item.ossUrlList = item.ossUrl ? item.ossUrl.split(';') : []
            if (item.bigNum) {
              if (previewMap[item.bigNum]) {
                previewMap[item.bigNum].list.push(item)
                previewMap[item.bigNum].totalPoint += item.point
              } else {
                previewMap[item.bigNum] = {
                  totalPoint: item.point,
                  list: [item]
                }
              }
            } else {
              if (previewMap[' ']) {
                previewMap[' '].list.push(item)
                previewMap[' '].totalPoint += item.point
              } else {
                previewMap[' '] = {
                  totalPoint: item.point,
                  list: [item]
                }
              }
            }
          }
          this.previewMap = previewMap
          this.previewVisible = true
        }
      } else {
        this.$message.error(res.message)
      }
    },

    //查询学生考试(预览试卷)
    async _studentBase () {
      this.dataLoading = true
      let params = {
        isTeachClass: this.reportType === 0 ? false : true
      }
      let resp = await reportApi.getStuBase(this.examId, this.studentId, params)
      this.dataLoading = false
      if (resp.success) {
        this.studentExamData = resp.body
        this.$previewRefresh()
        this.showReport = true
      }
    },

    _initNavScroll () {
      window.addEventListener('scroll', this._navScroll)
    },

    _navScroll () {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      this.postionClass = scrollTop >= 218 ? 'nav-fixed' : ''
    },
    handleClose () {
      this.dataLoading = false
    }
  },
  components: {
    NavBar
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #999999;

  .back {
    padding-right: 10px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -3px;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  .report-button {
    margin-left: 25px;

    .menu-tab {
      display: inline-block;
      font-size: 14px;
      margin: 0 10px;
      padding: 0 10px;
      color: #404040;
      line-height: 30px;
      font-weight: 500;
      border-radius: 20px;
      -webkit-transition: all 0.2s;
      transition: all 0.2s;
      cursor: pointer;
      color: #2877ff;
      background: #fff;
      border-color: #2877ff;
      border: 1px solid;
    }

    .menu-tab.actived {
      background: #2877ff;
      color: #fff;
    }
  }

  .project-mode {
    margin-right: 20px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -8px;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  .export-report {
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -5px;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  span {
    padding-left: 5px;
  }
}

.topic-info {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 15px;
  font-size: 16px;
}

.topic-title {
  font-size: 16px;
  margin-bottom: 15px;
}

.info-wrapper {
  display: flex;
  justify-content: center;
  height: 66px;
  position: relative;
  /*line-height: 66px;*/
  background: #fff;
  box-shadow: $box-shadow;
  border-radius: 4px;

  .el-button {
  }

  .mark {
    position: relative;
    width: 52px;

    span {
      position: absolute;
      top: 6px;
      left: -7px;
      width: 52px;
      height: 20px;
      line-height: 16px;
      text-align: center;
      transform: rotate(-45deg);
      z-index: 1;
      font-size: $font-size;
      color: #fff;
    }

    img {
      position: absolute;
      left: -4px;
      top: -4px;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > h4 {
      display: inline-block;
      font-size: $font-size-large;
      font-weight: bold;
      color: $color-text;
      margin-bottom: 10px;
    }

    .stud-info {
      font-size: $font-size;
    }

    .reletive {
      display: inline-block;
      padding: 0 10px 0 20px;

      img {
        vertical-align: middle;
      }

      span {
        padding: 0 10px;
        color: #999999;
        font-size: $font-size;
      }
    }

    .date {
      display: inline-block;
      color: #999999;
      font-size: $font-size;

      img {
        padding: 0 5px;
        margin-top: -4px;
        vertical-align: middle;
      }
    }
  }

  .tool {
    .select-round {
      display: inline-block;
      padding: 0 10px;
    }

    img {
      padding: 0 15px;
      vertical-align: middle;
    }
  }
}

.main {
  display: flex;
  flex-flow: row;

  .nav {
    width: 155px;
    //margin: 14px 20px 0 0;
  }
}

//预览试卷
.preview-common-box {
  /*position: relative;*/
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.previewImg {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  cursor: pointer;
}

.nav-wrap {
  position: relative;
  margin: 14px 20px 0 0;
  width: 155px;

  .nav-fixed {
    position: fixed;
    top: 10px;
  }
}
</style>

<style lang="scss">
.select-round {
  display: inline-block;

  .el-select__caret {
    color: #fff !important;
  }

  .el-select {
    width: 85px;

    .el-input {
      .el-input__inner {
        color: #fff;
        text-align: center;
        border-radius: 20px;
        border-color: $color-theme;
        background: $color-theme;
      }
    }
  }
}

.priview-img .el-image__inner,
.priview-img .el-image__error,
.priview-img > img {
  display: none;
}

// 隐藏自定义画布
.custom-canvas {
  display: none;
}
</style>